import React, { ReactElement } from 'react';

import { useTheme } from 'styled-components';

export const PenIcon = (): ReactElement => {
  const { mainColor } = useTheme();

  return (
    <div style={{ marginLeft: '10px', cursor: 'pointer' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        x="0"
        y="0"
        enableBackground="new 0 0 920.729 920.729"
        version="1.1"
        viewBox="0 0 920.729 920.729"
        xmlSpace="preserve"
        fill={mainColor}
      >
        <path d="M897.491 833.729a28.3 28.3 0 00-4.1.3l-245.7 31.8c-12.6 1.601-21.399-12.2-14.6-23 3.7-5.7 7.3-11.5 10.899-17.3 9.5-15.4-3.199-35.9-20.8-35.9-1.2 0-2.399.101-3.7.301l-322 48.399-38.5 5.8-105 15.801c-11.9 1.8-19.9 11.899-18.9 24 .4 5.399 2.6 10.5 6.1 14.3 4.1 4.5 9.8 7 16 7 1.2 0 2.4-.101 3.7-.3l383.8-57.7c13.101-2 22.101 12.8 14.4 23.6-2.5 3.4-5 6.9-7.5 10.3-6.9 9.4-5.3 25.101 2.7 33.2 4.1 4.2 9.3 6.4 14.8 6.4.6 0 1.3 0 1.899-.101h.201l331.3-42.199h.201c5.7-.9 10.7-4.2 14-9.301 3.601-5.6 4.9-12.5 3.3-18.699-2.6-10.101-11.4-16.701-22.5-16.701zM755.891 191.529c26.7-31.7 22.6-79-9.1-105.7l-81.101-68.2c-31.7-26.7-79-22.6-105.7 9.1l-32.1 38.1 195.9 164.8 32.101-38.1z" />
        <path d="M698.891 258.629L502.991 93.829 436.591 172.829 632.491 337.629z" />
        <path d="M.091 877.43c-.5 6.8 5.8 12.1 12.4 10.399l49.5-12.5-58.2-49-3.7 51.101zM236.69 807.229l367.701-436.8-195.901-164.8-367.7 436.7c-6.8 8.101-10.9 18.101-11.6 28.601l-8.7 120.8 72.8 61.3 117.3-29.5a50.653 50.653 0 0026.1-16.301z" />
      </svg>
    </div>
  );
};
